import useCollectedUserData from './useCollectedUserData';

const useCurrentStreakCount = () => {
  const { currentStreakCount } = useCollectedUserData();
  return currentStreakCount;
};

export default useCurrentStreakCount;
